// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-popup-parent--hidden {\n  overflow: hidden !important;\n}\n.el-popup-parent--hidden .fixed-header {\n  padding-right: 0.9375rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
